// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
/*
Example of calling the component from 'getPaymentTokenPresenter.jsx':

...
import EndpointsTestingComponent from './endpointsTestingComponent'
...

    <EndpointsTestingComponent
        paymentToken={paymentToken}
        onPaymentTokenPost={onPaymentTokenPost}
        onPaymentTokenClear={onPaymentTokenClear}
        {...props}
    />

*/
    export default
        function EndpointsTestingComponent(
        {
            paymentToken, // fetch result of '/Proxy/GetPaymentToken',
            // //------------------------------------------
            onPaymentTokenPost, // fetch '/Proxy/GetPaymentToken',
            // //------------------------------------------
            onPaymentTokenClear,
            // //------------------------------------------
            ...props
        }
        )
        {
            const [currencypaymentToken, setCurrencypaymentToken] = React.useState('')
            const [rRNpaymentToken, setRRNpaymentToken] = React.useState('')
            const [phoneNumberpaymentToken, setPhoneNumberpaymentToken] = React.useState('')
            const [amountpaymentToken, setAmountpaymentToken] = React.useState('')
            React.useEffect(() => {
                const str =
                    paymentToken === null || paymentToken === undefined
                    ? ""
                    : JSON.stringify(paymentToken, undefined, 2);

                document.getElementById("getPaymentTokenJsonId").innerHTML = str;
            }, [paymentToken])
            function listReferenceRender() {
                return (
                    <div className='container-lg'>
                        <a
                            href='current#'
                            onClick={(event) => {
                                event.preventDefault();
                                props.history.push('/endpoint-testing-list');
                            }}
                        >
                            testing components list
                        </a>
                    </div>
                )
            }
            function proxyGetPaymentTokenPaymentTokenTestingForm() {
                return (
                    <>
                        <hr/>
                        <hr/>
                        <fieldset className='container-lg'>
                            <legend>Input values for endpoint '<span style={{color: 'blue'}}>/api/Proxy/GetPaymentToken'</span></legend>
                            <p><span><b>Получение платёжного токена</b></span></p>
                            <p><span><b>Server call</b></span></p>
                            <form className='form-group' onReset={()=>onPaymentTokenClear()} onSubmit={event => {
                                event.preventDefault()
                                if (!currencypaymentToken) {
                                    alert("'Currency' is required.")
                                    return
                                }
                                if (!phoneNumberpaymentToken) {
                                    alert("'PhoneNumber' is required.")
                                    return
                                }
                                if (!amountpaymentToken) {
                                    alert("'Amount' is required.")
                                    return
                                }
                                onPaymentTokenPost({currency: currencypaymentToken, rRN: rRNpaymentToken, phoneNumber: phoneNumberpaymentToken, amount: amountpaymentToken})
                            }}>
                            <div style={{marginTop: 8}} className='card'>
                                <div className='card-body'>
                                    <p style={{marginTop: 10}}><b>Body object properties (InputView properties):</b></p>
                                        <div style={{marginTop: 16}}>
                                            <div  style={{marginTop: 0}}>
                                                <label htmlFor='currencypaymentTokenId' className='form-label'>Currency</label>
                                                <input type='text' id='currencypaymentTokenId' className='form-control' value={currencypaymentToken} onChange={event => setCurrencypaymentToken(event.target.value)}/>
                                                {!currencypaymentToken && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'Currency' is required.
                                                    </div>
                                                )}
                                            </div>

                                            <div  style={{marginTop: 16}}>
                                                <label htmlFor='rRNpaymentTokenId' className='form-label'>RRN</label>
                                                <input type='text' id='rRNpaymentTokenId' className='form-control' value={rRNpaymentToken} onChange={event => setRRNpaymentToken(event.target.value)}/>
                                            </div>

                                            <div  style={{marginTop: 16}}>
                                                <label htmlFor='phoneNumberpaymentTokenId' className='form-label'>PhoneNumber</label>
                                                <input type='text' id='phoneNumberpaymentTokenId' className='form-control' value={phoneNumberpaymentToken} onChange={event => setPhoneNumberpaymentToken(event.target.value)}/>
                                                {!phoneNumberpaymentToken && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'PhoneNumber' is required.
                                                    </div>
                                                )}
                                            </div>

                                            <div  style={{marginTop: 16}}>
                                                <label htmlFor='amountpaymentTokenId' className='form-label'>Amount</label>
                                                <input type='number' id='amountpaymentTokenId' className='form-control' value={amountpaymentToken} onChange={event => setAmountpaymentToken(Number(event.target.value))}/>
                                                {!amountpaymentToken && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'Amount' is required.
                                                    </div>
                                                )}
                                            </div>
                                            <a style={{marginTop: 4, color: 'gray'}} href='current#' onClick ={(event) => {event.preventDefault(); setAmountpaymentToken(11.11); }}>Insert sample data</a>

                                        </div>
                                    <input className='btn btn-primary' style={{marginTop: 24}} type = 'submit' value = 'Submit'/>
                                    <input className='btn' style={{marginTop: 24, marginLeft: 16}} type = 'reset' value = 'Clear'/>
                                </div>
                            </div>
                            </form>
                        </fieldset>
                        {proxyGetPaymentTokenPaymentTokenTestingResult()}
                    </>
                )
            }
            function proxyGetPaymentTokenPaymentTokenTestingResult() {
                return (
                    <>
                        <div style={{marginTop: 32}} className='container-lg'>
                            <p><b>Result of endpoint '<span style={{color: 'navy'}}>/api/Proxy/GetPaymentToken</span>':</b></p>
                            <span>{'--> string paymentToken'}</span>
                            <pre id="getPaymentTokenJsonId"></pre>
                        </div>
                    </>
                )
            }
            return (
                <>
                    {listReferenceRender()}
                    {proxyGetPaymentTokenPaymentTokenTestingForm()}
                </>
            )
        }
